var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress-tracker',_vm._g({attrs:{"uuid":_vm.uuid},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._t("default",null,null,{...scope, click: _vm.onClick})]}}],null,true)},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }